<template>
  <el-button
    link
    type="primary"
    @click="open"
  >
    凭证
  </el-button>
  <el-dialog
    v-model="visible"
    title="凭证附件"
    width="560px"
    append-to-body
  >
    <el-upload
      :auto-upload="false"
      :show-file-list="false"
      accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx"
      :on-change="upload"
    >
      <el-button
        type="primary"
        :loading="uploading"
      >
        上传凭证
      </el-button>
      <template #tip>
        <div class="tip">支持图片、PDF、Excel，单个文件不超过 10MB</div>
      </template>
    </el-upload>
    <el-table
      :data="rows"
      v-loading="loading"
    >
      <el-table-column
        prop="file_name"
        label="文件名"
      />
      <el-table-column
        prop="created_at"
        label="上传时间"
        width="180"
      />
      <el-table-column
        label="查看"
        width="80"
      >
        <template #default="{ row }">
          <el-link
            :href="row.file_url"
            target="_blank"
            type="primary"
          >
            打开
          </el-link>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script setup>
/* eslint-disable no-undef */
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { ledgerApi } from '../api'
const props = defineProps({
  bizType: { type: String, required: true },
  bizId: { type: Number, required: true },
})
const visible = ref(false),
  loading = ref(false),
  uploading = ref(false),
  rows = ref([])
const load = async () => {
  loading.value = true
  try {
    rows.value = (await ledgerApi.vouchers(props.bizType, props.bizId)) || []
  } finally {
    loading.value = false
  }
}
const open = () => {
  visible.value = true
  load()
}
const upload = async (item) => {
  uploading.value = true
  try {
    await ledgerApi.uploadVoucher(props.bizType, props.bizId, item.raw)
    ElMessage.success('凭证已上传')
    load()
  } catch (e) {
    ElMessage.error(e?.message || '上传失败')
  } finally {
    uploading.value = false
  }
}
</script>
<style scoped>
.tip {
  color: #8492a6;
  margin: 8px 0 14px;
}
</style>
